<template>
  <Banner text="Finalisez la configuration de votre magasin" :route="storeRoute" :icons="['🏪']" />
</template>

<script>
import { Banner } from "@estaly/ui";

export default {
  components: {
    Banner,
  },
  computed: {
    storeRoute() {
      return {
        path: "/admin/organization/stores",
        query: {
          ...this.$route.query,
          tab: "stores",
          page: "1",
          status: "information_to_be_completed",
        },
      };
    },
  },
};
</script>
